import { useEffect, useState, useCallback } from "react";

const navItems = [
  { label: "Accueil", href: "#accueil" },
  { label: "Nos expériences signature", href: "#experiences" },
  { label: "Présentation", href: "#apropos" },
  { label: "Nos expertises", href: "#services" },
  { label: "Pourquoi nous choisir", href: "#pourquoi" },
  { label: "Plug and Bar", href: "#plugandbar" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      setMobileOpen(false);
    },
    [],
  );

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-sm shadow-[0_1px_20px_rgba(0,0,0,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-10 lg:px-12 py-5 flex items-center justify-between">
        <img
          src="https://storage.readdy-site.link/project_files/90a975e3-fa94-47ff-988b-c34c350fc03a/cf22ba6a-2d92-4c72-b79c-293366647b08_Lalou-MaestraLogo-P.F.T.png?v=05391ca777dd9038fc82aa7d21e123ba"
          alt="Lalou Maestra"
          className={`h-12 md:h-14 w-auto object-contain transition-all duration-300 ${scrolled ? "" : "brightness-0 invert"}`}
        />

        <div className="hidden md:flex items-center space-x-8 lg:space-x-10">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "text-foreground-800 hover:text-primary-500"
                  : "text-white/85 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-foreground-800" : "text-white"
          }`}
          onClick={() => setMobileOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <i className="ri-menu-line text-xl" />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden absolute left-0 right-0 top-full bg-white/95 backdrop-blur-sm shadow-lg">
          <div className="flex flex-col px-6 md:px-10 py-4 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="text-foreground-800 hover:text-primary-500 transition-colors py-3 px-2 text-base cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}